export const gigCategoryOptions = [
  "Babysitting",
  "Car Washing",
  "Cleaning",
  "Dog Walking",
  "Elder Care",
  "Errands",
  "Event/Party Help",
  "Furniture Assembling",
  "Household Help",
  "Homework Helper",
  "Moving Help",
  "Pet Care",
  "Pet Sitting",
  "Sports Training",
  "Tech Help",
  "Tutoring",
  "Yard Work",
] as const;

export const businessListingCategoryOptions = [
  "Retail",
  "Food Service",
  "Customer Service",
  "Office / Admin",
  "Childcare",
  "Tutoring / Education",
  "Camp / After-School",
  "Cleaning / Janitorial",
  "Event Help",
  "Warehouse / Stock",
  "Delivery / Runner",
  "Yard / Outdoor Work",
  "Pet Care",
  "Creative / Design",
  "Social Media / Marketing",
  "Tech / IT Help",
  "Volunteer",
  "Other",
] as const;
